export const typeOfDrug = {
  lenalidomide: "Lenalidomide",
};
